<template lang="pug">
div(:class="[$style.faqSection, getReverseClass(block)]")
  Block(
    v-show="block.innerBlocks.length"
    v-for="(innerBlock, key) in block.innerBlocks"
    v-bind="{ id: 'faq-block' + '-' + key, class: 'faq-block' }"
    :key="`faqSection${key}`"
    :block="innerBlock"
    :lazy="lazy")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { FAQ_REVERSE } from "~/constants/blocks"
import { getBlockAttributes } from "~/utils/block"

export default defineComponent({
  name: "FaqSection",

  props: {
    block: {
      type: Object as () => Block,
      required: true
    },
    lazy: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    getReverseClass(block) {
      return getBlockAttributes(block).class.includes(FAQ_REVERSE) ? "reverse" : ""
    }
  }
})
</script>

<style lang="css" module>
.faqSection {
  @apply grid gap-ds-ml text-base;
  grid-template-columns: 1fr;
  grid-row-gap: calc(3vw + 16px);

  > *:nth-child(3) {
    & > div {
      @apply w-full;
    }
  }

  > *:nth-child(4),
  > *:nth-child(4) > a {
    @apply text-base underline transition-none;
    font-weight: 600;
  }

  :global {
    .av-heading {
      @apply m-0;
    }
  }
}

@screen md {
  .faqSection {
    @apply gap-x-ds-xxl;
    grid-template-columns: 160px 1fr;
    grid-row-gap: calc(3vw + 16px);
    grid-template-areas:
      "image header"
      "faq faq"
      "readMore readMore";

    > *:nth-child(1) {
      align-self: center;
      grid-area: header;
    }

    > *:nth-child(2) {
      grid-area: image;
      img {
        @apply mx-0;
      }
    }

    > *:nth-child(3) {
      grid-area: faq;
    }

    > *:nth-child(4),
    > *:nth-child(4) > a {
      @apply text-rebrandSm;
      grid-area: readMore;
    }
  }
}

@screen lg {
  .faqSection {
    > *:nth-child(2) {
      @apply self-start;
    }
  }

  :global(.faq-section-1-col) > .faqSection {
    > *:nth-child(1) {
      @apply self-center;
    }
  }

  :not(:global(.faq-section-1-col)) > .faqSection {
    /** Two-column layout */
    @apply gap-x-0 gap-y-ds-xl;
    grid-template-columns: 5fr 1fr 6fr;
    grid-auto-rows: minmax(100px, auto);
    grid-template-areas:
      "image gap header"
      "image gap faq"
      "image gap readMore";

    &:global(.reverse) {
      grid-template-columns: 6fr 1fr 5fr;
      grid-template-areas:
        "header gap image"
        "faq gap image"
        "readMore gap image";
    }

    > *:nth-child(1) {
      @apply self-end;
    }
  }
}
</style>
